<template>
  <div>
    <q-item v-if="items[0] === '_OLG_'" tag="label" :dense="dense">
      <q-item-section>
        <q-item-label>{{ label }}</q-item-label>
        <q-item-label caption
          >Please login or register for an account.</q-item-label
        >
      </q-item-section>
      <q-item-section side>
        <q-icon name="lock"></q-icon>
      </q-item-section>
    </q-item>
    <q-item v-else-if="items.length === 1" tag="label" :dense="dense">
      <q-item-section>
        <q-item-label>{{ label }}</q-item-label>
        <!-- <q-item-label caption>{{ description }}</q-item-label> -->
      </q-item-section>
      <q-item-section avatar>
        <q-toggle :dense="dense" v-model="filterInput" :val="items[0]" />
      </q-item-section>
    </q-item>
    <q-field v-else borderless :label="label" stack-label>
      <template v-slot:control>
        <div class="q-gutter-md">
          <q-checkbox
            v-model="filterInput"
            :dense="dense"
            :val="item"
            :label="parseLabel(item)"
            v-for="(item, index) in items"
            :key="index"
          />
        </div>
      </template>
    </q-field>
  </div>
</template>
<script>
export default {
  name: "CheckboxList",
  props: {
    id: {
      required: true,
      type: String,
      default: "",
    },
    label: {
      required: true,
      type: String,
      default: "",
    },
    description: {
      required: false,
      type: String,
      default: "",
    },
    items: {
      required: true,
      type: Array,
      default() {
        return [];
      },
    },
    dense: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Array,
    },
  },
  data() {
    return {
      filterInput: [],
    };
  },
  mounted() {
    this.$root.$on("reset-filter-input", () => {
      console.debug("reset-filter-input in checkboxlist");

      this.reset();
    });
  },
  beforeDestroy() {
    this.$root.$off("reset-filter-input");
  },
  methods: {
    reset() {
      if (this.filterInput.length) {
        this.filterInput = [];
      }
    },
    getYesNoLabel(input) {
      return input === "Y" ? "Yes" : "No";
    },
    parseLabel(val) {
      if (typeof val === "string") {
        if (val === "Y" || val === "N") {
          return this.getYesNoLabel(val);
        }

        return val;
      } else if (typeof val === "number") {
        return String(val);
      } else {
        return "";
      }
    },
  },
  watch: {
    filterInput(newVal) {
      this.$emit("update", this.id, newVal);
    },
    filter: {
      handler: function(newVal) {
        if (newVal && newVal.length && !this.filterInput.length) {
          this.filterInput = newVal;
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss" scoped></style>
